import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "prevBtn", "nextBtn"];

  connect() {
    this._onScroll = this.updateButtons.bind(this);

    this.updateButtons();
    this.trackTarget.addEventListener("scroll", this._onScroll, { passive: true });
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this._onScroll);
  }

  next() {
    this.trackTarget.scrollBy({ left: this.scrollAmount(), behavior: "smooth" });
  }

  prev() {
    this.trackTarget.scrollBy({ left: -this.scrollAmount(), behavior: "smooth" });
  }

  scrollAmount() {
    // Scroll by one tile width (first child) plus gap or fallback to 320px
    const firstTile = this.trackTarget.firstElementChild;
    return firstTile ? firstTile.offsetWidth + 20 : 320;
  }

  updateButtons() {
    const track = this.trackTarget;
    const atStart = track.scrollLeft <= 0;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = atStart;
      this.prevBtnTarget.classList.toggle("opacity-40", atStart);
      this.prevBtnTarget.classList.toggle("cursor-not-allowed", atStart);
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.disabled = atEnd;
      this.nextBtnTarget.classList.toggle("opacity-40", atEnd);
      this.nextBtnTarget.classList.toggle("cursor-not-allowed", atEnd);
    }
  }
}
